var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-content"},[_c('div',{staticClass:"md-layout"},[_c('div',{staticClass:"md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"},[_c('h1',[_vm._v("Enhancers v2")]),_c('md-button',{attrs:{"href":"/shortcuts/v2/enhancer/create"}},[_vm._v(" Create enhancer ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }